module.exports = __webpack_public_path__ + "static/media/toolsLimit.b5df881d.svg";